(function () {
  var ENDPOINT = '/apps/events';
  var SESSION_KEY = 'mordent_session_id';
  var OPT_OUT_KEY = 'mordent_analytics_opt_out';
  var EXCLUDED_REFERRERS = ['riffloom.com', 'myshopify.com', 'shopify.com', 'paypal.com'];
  var SENSITIVE = ['account', 'orders', 'checkouts', 'checkout', 'authentications', 'invoices', 'cart'];
  // Campaign labels must be plain words: no @, %, +, =, etc., so an email or token can't slip through.
  var SAFE_TEXT = /^[A-Za-z0-9_\-. ]{1,100}$/;
  // Opt-in regions: analytics stays off until the visitor accepts. Everywhere else is opt-out.
  // Two-letter ISO country codes.
  var OPT_IN_COUNTRIES = [
    // EU member states
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT',
    'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
    // EU territories that have their own country code (Åland, French overseas regions, Saint-Martin)
    'AX', 'GF', 'GP', 'MQ', 'RE', 'YT', 'MF',
    // Rest of the EEA
    'IS', 'LI', 'NO',
    // United Kingdom, plus Gibraltar and the Crown Dependencies, which have equivalent cookie rules
    'GB', 'GI', 'JE', 'GG', 'IM'
  ];
  // Provinces or states that are opt-in inside an otherwise opt-out country (country + subdivision code).
  var OPT_IN_SUBREGIONS = ['CAQC'];

  var mode = null; // null = consent not worked out yet, 'full' = tracking, 'off' = not tracking
  var pageSent = false; // this page's PAGE VISIT has been sent (or is waiting on the flow sync)
  var clickedButtons = {}; // button names already tracked on this page load (each is tracked once)

  // Product flags come from the "Compose your song" flow's saved session in localStorage
  // (written by custom.js; same key). Keep this key in step with STORAGE_KEY in custom.js.
  var FLOW_STORAGE_KEY = 'riffloomStartFlow_v3';
  var FLOW_MAX_AGE_MS = 30 * 86400000; // same 30-day lifetime custom.js gives a saved session

  function getSessionId() {
    var id = null;
    try { id = sessionStorage.getItem(SESSION_KEY); } catch (e) {}
    if (!id) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
      try { sessionStorage.setItem(SESSION_KEY, id); } catch (e) {}
    }
    return id;
  }

  function clearSessionId() {
    try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {}
  }

  function isOptedOut() {
    try { return localStorage.getItem(OPT_OUT_KEY) === '1'; } catch (e) { return false; }
  }

  // 1 = small (<768px), 2 = medium (768-1279px), 3 = large (1280px+)
  function getResolutionBucket() {
    var w = window.innerWidth || 1280;
    if (w < 768) return 1;
    if (w < 1280) return 2;
    return 3;
  }

  function getQaFlag() {
    return /(?:^|;\s*)TESTER_FLG=1(?:;|$)/.test(document.cookie) ? 1 : 0;
  }

  // Marks (or unmarks) this browser as a tester for one year.
  function setTester(on) {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = on
      ? 'TESTER_FLG=1; path=/; max-age=31536000; SameSite=Lax' + secure
      : 'TESTER_FLG=; path=/; max-age=0; SameSite=Lax' + secure;
    // The session row records qa_flg once, at its first event, so start a fresh session.
    clearSessionId();
    try { console.info('[mordent] Tester mode ' + (on ? 'ON' : 'OFF') + ' for this browser.'); } catch (e) {}
    return !!getQaFlag();
  }

  // ?mordent_tester=1 or ?mordent_tester=0 on any page toggles tester mode (handy on phones).
  // The page name never includes the query string, so this parameter isn't stored.
  function applyTesterParam() {
    try {
      var v = new URLSearchParams(location.search).get('mordent_tester');
      if (v === '1' && !getQaFlag()) setTester(true);
      else if (v === '0' && getQaFlag()) setTester(false);
    } catch (e) {}
  }

  function getReferrerDomain() {
    if (!document.referrer) return '';
    try {
      var host = new URL(document.referrer).hostname.toLowerCase();
      if (host === location.hostname) return '';
      for (var i = 0; i < EXCLUDED_REFERRERS.length; i++) {
        var d = EXCLUDED_REFERRERS[i];
        if (host === d || host.slice(-(d.length + 1)) === '.' + d) return '';
      }
      return host.slice(0, 100);
    } catch (e) {
      return '';
    }
  }

  function getParam(name) {
    try {
      // Parameter names are matched case-insensitively, so ?INT=x, ?int=x and ?Int=x all work.
      var v = '';
      var entries = new URLSearchParams(location.search).entries();
      for (var it = entries.next(); !it.done; it = entries.next()) {
        if (String(it.value[0]).toLowerCase() === name) { v = String(it.value[1] || '').trim(); break; }
      }
      return SAFE_TEXT.test(v) ? v : '';
    } catch (e) {
      return '';
    }
  }

  function scrubbedPageName(pathStr) {
    var segs = String(pathStr || '').split(/[?#]/)[0].split('/');
    var out = [];
    for (var i = 0; i < segs.length; i++) {
      var s = segs[i];
      if (SENSITIVE.indexOf(s.toLowerCase()) !== -1) {
        out.push(s);
        for (var j = i + 1; j < segs.length; j++) {
          out.push(/^[a-z_]{1,20}$/.test(segs[j]) ? segs[j] : ':redacted');
        }
        break;
      }
      var looksLikeId = /^\d{5,}$/.test(s) || (s.length >= 24 && /\d/.test(s) && /^[A-Za-z0-9_=]+$/.test(s));
      var looksLikeEmail = /@|%40/i.test(s);
      out.push(looksLikeId || looksLikeEmail ? ':redacted' : s);
    }
    return out.join('/').slice(0, 300);
  }

  function post(payload) {
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        // No cookies, so Shopify does not attach the logged-in customer ID to the proxied request.
        credentials: 'omit'
      }).catch(function () {});
    } catch (e) {}
  }

  // Reads the flow's saved selections and returns five 1/0 flags. Nothing is sent over the network
  // to do this, and it only runs for tracked visitors. Flags reflect what is currently selected in the flow
  // for the chosen package; any problem reading or parsing the entry gives all zeros.
  function getProductFlags() {
    var flags = { sonatina_flg: 0, sonata_flg: 0, rush_deliver_flg: 0, fourth_minute_flg: 0, slideshow_flg: 0 };
    try {
      var entry = JSON.parse(localStorage.getItem(FLOW_STORAGE_KEY) || 'null');
      if (!entry || typeof entry.savedAt !== 'number' || !entry.state) return flags;
      if (Date.now() - entry.savedAt > FLOW_MAX_AGE_MS) return flags;

      var pkg = entry.state.pkg;
      if (pkg !== 'sonatina' && pkg !== 'sonata') return flags;
      // Only the selected package's add-ons count; the other package's toggles may still be stored.
      var items = (entry.state.items && entry.state.items[pkg]) || {};

      if (pkg === 'sonatina') flags.sonatina_flg = 1;
      if (pkg === 'sonata') flags.sonata_flg = 1;
      if (items.rush === true) flags.rush_deliver_flg = 1;
      if (items.extraMinute === true) flags.fourth_minute_flg = 1;
      if (items.slideshow === true) flags.slideshow_flg = 1;
    } catch (e) {}
    return flags;
  }

  // Sends one event linked to the tab's session. Only ever called while mode === 'full'.
  function sendFull(eventName, buttonName) {
    if (mode !== 'full') return;
    var flags = getProductFlags();
    post({
      session_id: getSessionId(),
      event: eventName,
      page_nm: scrubbedPageName(location.pathname),
      int_nm: eventName === 'PAGE VISIT' ? getParam('int') : '',
      button_nm: buttonName || '',
      referrer_domain: getReferrerDomain(),
      utm_source: getParam('utm_source'),
      utm_medium: getParam('utm_medium'),
      utm_campaign: getParam('utm_campaign'),
      resolution_bckt: getResolutionBucket(),
      qa_flg: getQaFlag(),
      sonatina_flg: flags.sonatina_flg,
      sonata_flg: flags.sonata_flg,
      rush_deliver_flg: flags.rush_deliver_flg,
      fourth_minute_flg: flags.fourth_minute_flg,
      slideshow_flg: flags.slideshow_flg
    });
  }

  // Sends this page's PAGE VISIT once. If an order was handed to the cart, custom.js first reconciles the
  // saved selections with the cart (window.riffloomFlowSynced); wait for that, but never more than 1.2 s.
  function sendPageVisit() {
    if (pageSent || mode !== 'full') return;
    pageSent = true;
    var synced = window.riffloomFlowSynced;
    if (synced && typeof synced.then === 'function') {
      var done = false;
      var go = function () { if (!done) { done = true; sendFull('PAGE VISIT', ''); } };
      synced.then(go, go);
      setTimeout(go, 1200);
    } else {
      sendFull('PAGE VISIT', '');
    }
  }

  function privacyApi() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return p && typeof p.analyticsProcessingAllowed === 'function' ? p : null;
  }

  function analyticsAllowed() {
    if (isOptedOut()) return false;

    var p = privacyApi();
    if (!p) return false; // Fail closed: no consent information means no tracking.

    // An explicit answer from the banner (or the opt-in/opt-out controls) always wins.
    var answer = '';
    try {
      if (typeof p.currentVisitorConsent === 'function') {
        answer = String((p.currentVisitorConsent() || {}).analytics || '');
      }
    } catch (e) {}
    if (answer === 'yes') return true;
    if (answer === 'no') return false;

    // No explicit answer yet: the region decides the default.
    var region = '';
    try {
      if (typeof p.getRegion === 'function') region = String(p.getRegion() || '').toUpperCase().replace(/[^A-Z]/g, '');
    } catch (e) {}
    return defaultForRegion(region);
  }

  // Default for a visitor who hasn't answered: false in opt-in regions or when the region is unknown,
  // true everywhere else. Shopify's region looks like "CAQC" (country + subdivision) or just "FR".
  function defaultForRegion(region) {
    if (!/^[A-Z]{2}/.test(region)) return false; // Unknown region: don't track.
    for (var i = 0; i < OPT_IN_SUBREGIONS.length; i++) {
      if (region.indexOf(OPT_IN_SUBREGIONS[i]) === 0) return false;
    }
    if (OPT_IN_COUNTRIES.indexOf(region.slice(0, 2)) !== -1) return false;
    return true;
  }

  // Re-reads consent after a change and switches tracking on or off.
  function refreshMode() {
    if (!mode) return; // begin() hasn't run yet and will read the new answer itself
    if (analyticsAllowed()) {
      mode = 'full';
      sendPageVisit(); // counts this page if it wasn't counted before consent
    } else {
      mode = 'off';
      clearSessionId();
    }
  }

  function begin() {
    if (mode) return;
    if (analyticsAllowed()) {
      mode = 'full';
      sendPageVisit();
    } else {
      mode = 'off';
      clearSessionId();
    }
  }

  function setOptOut(on) {
    try {
      if (on) localStorage.setItem(OPT_OUT_KEY, '1');
      else localStorage.removeItem(OPT_OUT_KEY);
    } catch (e) {}

    if (on && mode) {
      mode = 'off';
      clearSessionId();
    }

    var p = privacyApi();
    if (p && typeof p.setTrackingConsent === 'function') {
      try {
        p.setTrackingConsent({ analytics: !on }, function () { refreshMode(); });
      } catch (e) {}
    }
  }

  // Logs one BUTTON CLICK, once per page load per name, for tracked visitors only. Used by the click
  // listener below and callable from page scripts for things that aren't clicks (e.g. a popup opening).
  function trackButton(rawName) {
    if (mode !== 'full') return;
    var name = String(rawName || '').slice(0, 100);
    if (!name || clickedButtons[name]) return;
    clickedButtons[name] = true;
    sendFull('BUTTON CLICK', name);
  }

  window.mordentAnalytics = {
    trackButton: trackButton,
    optOut: function () { setOptOut(true); },
    optIn: function () { setOptOut(false); },
    isTracking: function () { return mode === 'full'; },
    setTester: function (on) { return setTester(on === undefined ? true : !!on); },
    isTester: function () { return !!getQaFlag(); }
  };

  applyTesterParam();

  // The visitor answered the banner on this page. Accepting starts tracking straight away (and counts
  // this page if it wasn't counted yet); declining stops it.
  document.addEventListener('visitorConsentCollected', function (e) {
    if (!mode) return; // begin() hasn't run yet and will read the new answer itself
    var allowed = !!(e.detail && e.detail.analyticsAllowed) && !isOptedOut();
    if (allowed) {
      mode = 'full';
      sendPageVisit();
    } else {
      mode = 'off';
      clearSessionId();
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;

    // Opt-out and opt-in controls are handled first and never tracked.
    // They can be buttons with the data attributes, or plain links to #analytics-off / #analytics-on
    // (for editors that strip buttons and data attributes, such as Shopify's policy editor).
    if (t.closest('[data-analytics-opt-out], a[href="#analytics-off"]')) { e.preventDefault(); setOptOut(true); return; }
    if (t.closest('[data-analytics-opt-in], a[href="#analytics-on"]')) { e.preventDefault(); setOptOut(false); return; }

    // Only elements with a data-button-name attribute are tracked, and only for tracked visitors.
    var el = t.closest('[data-button-name]');
    if (!el) return;
    trackButton(el.getAttribute('data-button-name'));
  }, true);

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { begin(); });
  } else {
    begin();
  }
})();